<template>
  <div>
    <CoreContentArea>
      <template v-if="data">
        <CoreCard
          :center="false"
          icon="tools"
          :title="data.title"
          class="mb-8"
        />
        <TenantAreaPay
          class="mb-8"
          v-bind="data"
        />
        <TenantAreaManuals
          class="mb-8"
          v-bind="data"
        />
        <TenantAreaFixFlow
          class="mb-8"
          v-bind="data"
        />
        <TenantAreaContacts
          v-bind="data"
        />
      </template>
    </CoreContentArea>
    <BlockFooter />
  </div>
</template>

<script>
import { tenantArea } from '@io';
import { BlockFooter } from '@c/Block';
import TenantAreaManuals from './TenantAreaManuals';
import TenantAreaFixFlow from './TenantAreaFixFlow';
import TenantAreaContacts from './TenantAreaContacts';
import TenantAreaPay from './TenantAreaPay';

export default {
  name: 'TenantArea',

  components: {
    BlockFooter,
    TenantAreaManuals,
    TenantAreaFixFlow,
    TenantAreaContacts,
    TenantAreaPay,
  },

  data: () => ({
    data: null,
  }),

  async created() {
    this.data = await tenantArea.get();
  },
};
</script>
